module.exports = __webpack_public_path__ + "img/grave-qr-summer-1.474ecd2c.png";